import axios from 'axios';
import {put, takeLatest, takeEvery} from 'redux-saga/effects';
import {actionUpdate} from '@stackhouseos/box-core';
import {updateStepData} from '@stackhouseos/flow-client';
import sortBy from 'lodash/sortBy';

function* appInit({payload}) {
  const {flowName, reducerName} = payload;
  const [slug] = /* ['localhost:3000']; */ window.location.host.split('.');
  const skipMaintenance = window.location.pathname === '/skip';

  try {
    const account = yield axios.get('/api/account/' + slug);
    yield put(actionUpdate('app', 'account', account.data));
    yield put(actionUpdate('app', 'skip', skipMaintenance));

    const {sortedData} = account.data;

    const categories = yield axios.get('/api/categories/' + account.data.id);
    const categoriesSorted = sortBy(categories.data, item =>
      sortedData.categories.indexOf(item._id.toString()),
    );
    yield put(actionUpdate('categories', 'items', categoriesSorted));

    const products = yield axios.get('/api/products/' + account.data.id);
    yield put(actionUpdate('products', 'items', products.data));

    yield put(updateStepData(flowName, 'success', true));
  } catch (error) {
    console.log('TCL: function*appInit -> error', error);
    yield put(updateStepData(flowName, 'error', error));
  } finally {
    yield put({type: 'flow/next', payload: {flowName, reducerName}});
  }
}

function* start({payload}) {
  const {flowName, reducerName} = payload;
  yield put({type: 'flow/next', payload: {flowName, reducerName}});
}

export default function* homeSaga() {
  yield takeLatest('START', start);
  yield takeEvery('APP_INIT', appInit);
}
